export const Locales = ['au', 'gb', 'us'] as const;
export type Locale = (typeof Locales)[number];
export const isLocale = (locale: string | undefined | null): locale is Locale => {
  return locale === 'us' || locale === 'gb' || locale === 'au';
};
